import React, { Fragment } from "react";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { List } from "linqts";

import theme from "../../theme";
import { StatementTransaction, StatementInformationDetail } from "../../types/types";
import { formatCurrency } from "../../utils/helpers";
import { useIsMaguireEnabled } from "../../utils/maguireHelper";

export interface ServiceTransactionProps {
  transactions: StatementTransaction[] | StatementInformationDetail[];
  isWeeklyStatement?: boolean;
}
const ServiceTransaction = (props: ServiceTransactionProps) => {
  const isMaguireEnabled = useIsMaguireEnabled();
  const { transactions, isWeeklyStatement } = props;
  if (!props.transactions || props.transactions.length === 0) return null;
  const totalAmount = isMaguireEnabled
    ? (props.transactions as StatementInformationDetail[]).reduce(
        (sum, current) => sum + (current.totalMovement ?? 0),
        0
      )
    : (props.transactions as StatementTransaction[]).reduce((sum, current) => sum + (current.totalMovement ?? 0), 0);
  if (isMaguireEnabled) {
    if (isWeeklyStatement) {
      const serviceDescription = (txn: StatementInformationDetail) => {
        return `${txn.transactionDescription}`;
      };
      const arr = new List<StatementInformationDetail>(props.transactions as StatementInformationDetail[]);
      const groupedByTxnId = arr.GroupBy((t) => t.transactionId ?? "");
      const uniqueTransactions = Object.values(groupedByTxnId).map((g) => g[0]);
      const transactionsByService = new List<StatementInformationDetail>(uniqueTransactions).GroupBy(
        (t) => t.serviceName ?? ""
      );
      const totalAmount = uniqueTransactions.reduce((sum, current) => sum + (current.totalMovement ?? 0), 0);

      return (
        <>
          {Object.keys(transactionsByService).map((service, index) => (
            <Fragment key={index}>
              <Grid item xs={12}>
                <Typography style={{ color: theme.palette.info.dark }}>{service}</Typography>
              </Grid>
              {transactionsByService[service].map((txn, idx) => (
                <Grid container spacing={2} key={idx}>
                  <Grid item xs={9}>
                    {serviceDescription(txn)}
                  </Grid>
                  <Grid item xs={3}>
                    <Grid container justifyContent="flex-end">
                      {formatCurrency(txn.totalMovement)}
                    </Grid>
                  </Grid>
                </Grid>
              ))}
            </Fragment>
          ))}
          <Grid container spacing={2}>
            <Grid item xs={9}>
              <Grid container justifyContent="flex-end">
                Daily Total
              </Grid>
            </Grid>
            <Grid item xs={3}>
              <Grid container justifyContent="flex-end">
                {formatCurrency(totalAmount)}
              </Grid>
            </Grid>
          </Grid>
        </>
      );
    } else {
      const serviceDescription = (txn: StatementTransaction) => {
        return `${txn.entryDescr} - ${txn.entryType} - ${txn.sessionType ?? ""}`;
      };
      const arr = new List<StatementTransaction>(props.transactions as StatementTransaction[]);
      const transactionsByService = arr.GroupBy((t) => t.serviceName ?? "");
      return (
        <>
          {Object.keys(transactionsByService).map((service, index) => (
            <Fragment key={index}>
              <Grid item xs={12}>
                <Typography style={{ color: theme.palette.info.dark }}>{service}</Typography>
              </Grid>
              {transactionsByService[service].map((txn, idx) => (
                <Grid container spacing={2} key={idx}>
                  <Grid item xs={9}>
                    {serviceDescription(txn)}
                  </Grid>
                  <Grid item xs={3}>
                    <Grid container justifyContent="flex-end">
                      {formatCurrency(txn.totalMovement)}
                    </Grid>
                  </Grid>
                </Grid>
              ))}
            </Fragment>
          ))}
          <Grid container spacing={2}>
            <Grid item xs={9}>
              <Grid container justifyContent="flex-end">
                Daily Total
              </Grid>
            </Grid>
            <Grid item xs={3}>
              <Grid container justifyContent="flex-end">
                {formatCurrency(totalAmount)}
              </Grid>
            </Grid>
          </Grid>
        </>
      );
    }
  } else {
    const serviceDescription = (txn: StatementTransaction) => {
      return `${txn.entryDescr} - ${txn.entryType} - ${txn.sessionType ?? ""}`;
    };
    const arr = new List<StatementTransaction>(props.transactions as StatementTransaction[]);
    const transactionsByService = arr.GroupBy((t) => t.serviceName ?? "");
    return (
      <>
        {Object.keys(transactionsByService).map((service, index) => (
          <Fragment key={index}>
            <Grid item xs={12}>
              <Typography style={{ color: theme.palette.info.dark }}>{service}</Typography>
            </Grid>
            {transactionsByService[service].map((txn, idx) => (
              <Grid container spacing={2} key={idx}>
                <Grid item xs={9}>
                  {serviceDescription(txn)}
                </Grid>
                <Grid item xs={3}>
                  <Grid container justifyContent="flex-end">
                    {formatCurrency(txn.totalMovement)}
                  </Grid>
                </Grid>
              </Grid>
            ))}
          </Fragment>
        ))}
        <Grid container spacing={2}>
          <Grid item xs={9}>
            <Grid container justifyContent="flex-end">
              Daily Total
            </Grid>
          </Grid>
          <Grid item xs={3}>
            <Grid container justifyContent="flex-end">
              {formatCurrency(totalAmount)}
            </Grid>
          </Grid>
        </Grid>
      </>
    );
  }
};
export default ServiceTransaction;
